import {  AppService } from '../../../services/app.service';

export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			'items': [
				
			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Tableau de bord',
					
                    root: true,
					icon: 'fas fa-home',
					page: 'dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
                    right: true
				},
				{
					title: 'Assistant maternel',
					root: true,
					icon: 'fas fa-baby-carriage',
					page: 'assistmat',
                    right: 'c9b30a03a0ca511185cc9850667ffca543dea3b1'
                     
				},
				{
						title: 'Assistant maternel en MAM',
						root: true,
						icon: 'fas fa-baby-carriage',
						page: 'amatam',
						right: '1ad9f64adc9379b8f65ff91f6ff8294631c08522',
						submenu : [
							{
							title: 'MAM',
							root: true,
							icon: 'fas fa-user-friends',
							page: 'mam',
		                    right: '918effe34cc14828cb7b479e520af4ce1e6d12a6'
							}
						]
	                   //
				},
				{
	                    title: 'Assistant familial',
	                    root: true,
	                    icon: 'fas fa-child',
	                    page: 'assistfam',
					    right: 'c9b30a03a0ca511185cc9850667ffca543dea3b1'

				 },                
				{
					title: 'Enfant',
					root: true,
					icon: 'la la-child',
					page: 'enfant',
                    right: '0b74647d860cdfb35d69ff36fe95960a8ab6c483'
				},
				
				
				
				
                {
					title: 'Commission',
					root: true,
					icon: 'la la-share-alt',
					page: '',
                    right: '554e2418dae1f59b047571384742517aeffc5365',
                    submenu : [
                        {
						title: 'CAM',
						root: true,
						icon: 'fas fa-info-circle',
						page: 'ca',
	                    right: '09acbb7d1da8aa3daff4c1ec8076713606974c64'
	
						},
						{
						title: 'GAT',
						root: true,
						icon: 'fas fa-info-circle',
						page: 'gat',
	                    right: '04c0e4d7846404cca6b4e489d2aa61c40ae1a352'
	
						},
                        {
							title: 'CCPD',
							root: true,
							icon: 'fas fa-info-circle',
							page: 'ccpd',
		                    right: 'de739e26b63e05b5ecea60f63dd4fe2c2c383b08'
		
						}					
						
                    ]
				},
				{
									title: 'Liste',
									root: true,
									icon: 'la la-list',
									page: '',
				                    right: '735cf1665d0fd36f4865e4bc7439abe369572e04',
				                    submenu : [
				                        {
										title: 'Formation',
										root: true,
										icon: 'la la-school',
										page: 'formation',
					                    right: 'e74895d84e9d137071af5f48813668c5c9525c89'
					
										},
										{
										title: 'RIPA',
										root: true,
										icon: 'la la-handshake',
										page: 'ripa',
					                    right: 'edccc6b39b4522c342e0147af33932a1daf3f171'
					
										},
				                       			
										
				                    ]
				},
                {
					title: 'RPE',
					root: true,
					icon: 'fas fa-hotel',
					page: 'ram',
                    right: 'ac698b848e1df138672f7b030cbeb3215de68fe2'
				},
			    {
					title: 'EAJE',
					root: true,
					icon: 'fas fa-building',
					page: 'eaje',
                    right: '42e53cd4fccff93fafd7b57f255042561c259446',
                    submenu : [
                         {
                        title: 'Structure de gestion',
                        root: true,
                        icon: 'fas fa-building',
                        page: 'structgestion',
                        right: '42e53cd4fccff93fafd7b57f255042561c259446'                        
                        }
                    ]
				},
							{
			    "title": "ALSH",
			    "root": true,
			    "icon": "fas fa-child",
			    "page": "alsh",
			    "right": "7070ee42f38b093ec4a76ae2e55aebb3d88f0f26"
			},
				{
					title: 'Portail',
					root: true,
					icon: 'fas fa-users',
					page: 'webamat',
                    right: 'a2a27f2931bc00561bdb911997acc7d33c3926ee'
				},
				
				
				{
					title: 'Statistiques',
					root: true,
					icon: 'fas fa-chart-bar',
                    right: '605eed9e61fbb522be0ae195715f51e54301f60e'

				},
                
		
/* MENU_OJECT */
			]
		},
	};
	private _ap:any;
		
		constructor(

				private appService:AppService,
				
			) {
				this._ap=this. appService;
				
	}
	public get configs(): any {
		return this.defaults;
	}
	
	public   setItems(items:any[]) :any {
			this.defaults["aside"]["items"]=items
			return this.configs;
		}
		
    public  async getConfigs(){
			 const t= await this._ap.getMenuList({}).toPromise();
			 return t 	;	
			
	}
}
